import { render } from "./Create.vue?vue&type=template&id=47c60885&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=47c60885&scoped=true&lang=less"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c60885"]])

export default __exports__